import React, { useEffect, useState } from "react";
import {
  Button,
  DropdownMenuNew,
  LogoLoader,
  showToast,
  TableAdv,
} from "../../../../../components";
import AddAccountModel from "../../Modals/AddAccountModel";
import { mapTableRows } from "../../../../../utils";
import AddUsersListModel from "../../Modals/AddUsersListModel";
import {
  deleteIntegration,
  getAllIntegrations,
  updateIntegrations,
} from "../../../../../redux/slices/setting/settingApi";
import { usePagination } from "../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import {
  deleteIntegrationBs,
  getAllIntegrationsBs,
  updateIntegrationsBs,
} from "../../../../../redux/slices/ats/benchSales/benchSalesApi";
import { formatWords2 } from "../../../../../utils/stringUtils";

const ResumeSearch = ({
  category,
  type,
  integrations,
  onUpdate,
  selectedModule,
}) => {
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [integrationData, setIntegrationData] = useState([]);
  const [valueChange, setValueChange] = useState(false);
  const [integrationAccess, setIntegrationAccess] = useState({});
  const [editData, setEditData] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const { value } = useSelector((state) => state.totalCount);

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const totalCount = value?.integrationCount?.data || 0;

  const dispatch = useDispatch();

  const tableColumn = [
    {
      key: "actions",
      label: "",
      columnMenu: false,
      render: (row) => (
        <DropdownMenuNew
          MenuSection={
            <div className="flex flex-col">
              <Button
                title={"Add Users"}
                icon={"group_add"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => {
                  setIsModalOpen(true);
                  setEditData(integrationData[row.id]);
                }}
              />

              <Button
                title={"Edit"}
                icon={"edit_square"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => {
                  setShowConnectModal(true);
                  setEditData(integrationData[row.id]);
                  setIsEdit(true);
                }}
              />

              {/* <Button                   //CONFIRMED WITH MOHSIN
                title={"Delete"}
                icon={"delete"}
                variant="text"
                color="black"
                size="sm"
                className="!justify-start py-1"
                onClick={() => handleDelete(row.uiid)}
              /> */}
            </div>
          }
        >
          <Button
            type="icon"
            variant="text"
            icon={"more_vert"}
            color="black"
            label="true"
          />
        </DropdownMenuNew>
      ),
    },
    {
      key: "accountName",
      label: "Account Name",
      columnMenu: false,
    },
    { key: "displayName", label: "Display Name", columnMenu: false },
    { key: "noofUsers", label: "No of Users", columnMenu: false },
    {
      key: "access",
      label: "Access",
      columnMenu: false,
      render: (row) => (
        <div className="flex items-center">
          <Button
            type="icon"
            variant="text"
            icon={row.status === 1 ? "toggle_on" : "toggle_off"}
            color={row.status === 1 ? "success" : "black"}
            size="sm"
            onClick={() =>
              toggleIntegrationAccess(row.uiid, row.status === 1 ? 2 : 1)
            }
          />
        </div>
      ),
    },
    { key: "message", label: "Message", columnMenu: false },
  ];

  const rowDat = Array.from({ length: integrationData?.length }, (_, i) => ({
    id: i,
    accountName:
      category === 3
        ? type === 1
          ? `Monster`
          : type === 2
            ? `Career Builder`
            : "-"
        : "-",
    displayName: formatWords2(integrationData?.[i]?.name) || "-",
    noofUsers: integrationData?.[i]?.accessIds?.length || "-",
    access: `User ${i + 1}`,
    uiid: integrationData?.[i]?.uiid,
    status: integrationAccess[integrationData?.[i]?.uiid],
    // message: integrationData?.[i]?.config?.message || "-",
    message: integrationData?.[i]?.config?.message || "-",
  }));

  const mappedrows = mapTableRows(rowDat, tableColumn);

  useEffect(() => {
    if (selectedModule !== "bs") {
      fetchIntegrationData();
    }
  }, [dispatch, limit, page]);

  useEffect(() => {
    if (selectedModule !== "bs") {
      fetchTotalCount();
      fetchIntegrationData();
    }
  }, [selectedModule]);

  const fetchTotalCount = () => {
    if (selectedModule === "bs") {
      dispatch(
        totalCountStart({
          collection: "integrations",
          coll: "Integration",
          tname: "integrationCountBs",
          filters: {
            category: { type: "NONE", value: category },
            type: { type: "NONE", value: type },
          },
          app: "bs",
        }),
      );
    } else if (selectedModule === "ats") {
      dispatch(
        totalCountStart({
          collection: "integrations",
          coll: "Integration",
          tname: "integrationCount",
          filters: {
            category: { type: "NONE", value: category },
            type: { type: "NONE", value: type },
          },
          app: "ats",
        }),
      );
    }
  };

  const fetchIntegrationData = async () => {
    setLoading(true);

    try {
      const params = {
        coll: selectedModule === "bs" ? "Integrationbs" : "Integration",
        fil: JSON.stringify({
          category: { type: "NONE", value: category },
          type: { type: "NONE", value: type },
        }),
        lim: limit,
        pg: page,
      };

      const response =
        selectedModule === "bs"
          ? await getAllIntegrationsBs(params)
          : await getAllIntegrations(params);

      if (response?.success) {
        const list = response.data?.data || [];

        const accessMap = list.reduce((acc, item) => {
          acc[item.uiid] = item.status;
          return acc;
        }, {});

        setIntegrationData(list);
        setIntegrationAccess(accessMap);
      } else {
        setIntegrationData([]);
        showToast("Unable to fetch integration data", "error");
      }
    } catch (error) {
      console.error("Error fetching integration data:", error);
      setIntegrationData([]);
      showToast("Something went wrong while fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  const toggleIntegrationAccess = async (uiid, status) => {
    const newintegrationAccess = { ...integrationAccess, [uiid]: status };

    try {
      const payload = [
        {
          type: "SET",
          value: { status, "config.message": "" },
        },
      ];

      // if (status === 2) {
      //   payload.push({
      //     type: "SET",
      //     value: { "config.message": "" },  // clear message{ uiid, payload }
      //   });
      // }
      setLoading(true);
      const updateStatus =
        selectedModule === "bs"
          ? await updateIntegrationsBs({ uiid, payload })
          : await updateIntegrations({ uiid, payload });
      if (updateStatus?.success) {
        setIntegrationAccess(newintegrationAccess);
        showToast("Integration status updated successfully", "success");
        setLoading(false);
        fetchIntegrationData();
      } else {
        showToast("Failed to update Integration status", "error");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error updating integration status:", err);
      showToast("Failed to update Integration status", "error");
      setLoading(false);
    }
  };

  const handleDelete = async (uiid) => {
    if (!uiid) return;
    try {
      const response =
        selectedModule === "bs"
          ? await deleteIntegrationBs({ uiid, coll: "Integrationbs" })
          : await deleteIntegration({ uiid, coll: "Integration" });

      if (response?.success) {
        showToast("Integration deleted successfully", "success");
        fetchIntegrationData();
      } else {
        showToast("Failed to delete integration", "error");
      }
    } catch (error) {
      console.warn("Error while deleting integration: ", error);
      showToast("Failed to delete integration", "error");
    }
  };

  const getServiceName = () => {
    const configs = {
      3: {
        1: "Monster",
        2: "Career Builder",
        3: "Shine",
        4: "Naukri",
        5: "LinkedIn",
        6: "ZipRecruiter",
        7: "Jora",
      },
      6: {
        1: "Open AI",
      },
      11: {
        1: "G-suite",
        2: "Outlook",
        3: "Mailgun",
        4: "AWS SES",
        5: "Instantly",
      },
      1: { 1: "VOIP Office CRM", 2: "ZOOM" },
      2: { 1: "VOIP Office CRM" },
      7: { 1: "Google Search API" },
    };
    return configs[category]?.[type] || "Service";
  };

  const serviceName = getServiceName();

  const handleSave = (data) => {
    onUpdate(data, () => {
      fetchIntegrationData();
      fetchTotalCount();
    });
    setShowConnectModal(false);
    // setShowTable(true);
  };

  if (selectedModule === "bs") {
    return (
      <div className="mt-3">
        <p>
          This feature is not available for Bench Sales. However, you can
          configure the following features:
        </p>
        <div className="ms-3">
          <h6 className="text-dark my-2 -ms-1">
            Available Features for Bench Sales:
          </h6>
          <p>
            1. <strong>Kult AI (Text)</strong> — Marketplace &gt; AI (Beta) &gt;
            Kult AI (Text) &gt; Setup / Configure
          </p>
          <p>
            2. <strong>Apollo</strong> — Marketplace &gt; Productivity &gt;
            Apollo &gt; Setup / Configure
          </p>
          <p>
            3. <strong>G-Suite</strong> — Marketplace &gt; Bulk Email &gt;
            G-Suite &gt; Setup / Configure
          </p>
          <p>
            4. <strong>Outlook</strong> — Marketplace &gt; Bulk Email &gt;
            Outlook &gt; Setup / Configure
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      {!integrationData || integrationData?.length <= 0 ? (
        <>
          <div className="flex justify-end items-center gap-2 mb-1">
            <Button
              title={`Connect ${serviceName}`}
              size="sm"
              onClick={() => setShowConnectModal(true)}
            />
          </div>
          <p>
            Integration with {serviceName} for resume search is a
            straightforward process through Tektree Inc. Follow these steps.
          </p>
          <div className="font-bold mt-5 mb-2">
            Here are the steps to configure the Integrations
          </div>
          <ol className="list-decimal list-inside">
            <li>
              Contact your {serviceName} Account Manager to initiate the
              process.
            </li>
            <li>Request the necessary credentials.</li>
            <li>
              Click on <b>"Connect {serviceName}"</b> and provide the necessary
              details.
            </li>
            <li>
              Save the entered information to add your account successfully.
            </li>
            <li>
              Once saved, you can allocate credits to your team for utilization.
            </li>
            <li>
              Get ready to find top talent with {serviceName}'s extensive
              network and tools.
            </li>
          </ol>
        </>
      ) : (
        // : loading ? (
        //   <div className="flex-1 flex justify-center items-center">
        //     <LogoLoader />
        //   </div>
        // )
        <TableAdv
          columns={tableColumn}
          rows={mappedrows}
          showSlNo={false}
          showCheckbox={false}
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          isLoading={loading}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: false,
            add: [
              {
                component: (
                  <Button
                    title={"Add Account"}
                    size="sm"
                    onClick={() => {
                      setShowConnectModal(true);
                      setEditData();
                      setIsEdit(false);
                    }}
                  />
                ),
              },
            ],
          }}
        />
      )}

      <AddAccountModel
        isOpen={showConnectModal}
        onClose={() => setShowConnectModal(false)}
        category={category}
        type={type}
        existingData={editData ? editData : null}
        // onSave={onUpdate}
        onSave={handleSave}
        // isEditMode={!!integration}
        isEditMode={isEdit}
        selectedModule={selectedModule}
      />
      <AddUsersListModel
        isOpen={isModalOpen}
        integrationId={editData ? editData?.uiid : null}
        onClose={() => {
          setIsModalOpen(false);
          fetchIntegrationData();
        }}
        onValueChange={(val) => setValueChange(val)}
        showConnectModal={() => setShowConnectModal(true)}
        category={category}
        type={type}
        selectedModule={selectedModule}
      />
    </div>
  );
};

export default ResumeSearch;
